import { NgModule }                        from '@angular/core';
import { BypassSecurityTrustHtmlPipe }     from '@shared/pipes/bypass-security-trust-html.pipe';
import { DateLocaleFormatPipe }            from '@shared/pipes/date-locale-format.pipe';
import { ExternalToInternalLinkPipe }      from '@shared/pipes/external-to-internal-link.pipe';
import { KeyValueNotSortingByDefaultPipe } from '@shared/pipes/keyvalue-not-sorting-by-default.pipe';
import { LineBreakHtmlConverterPipe }      from '@shared/pipes/line-break-html-converter';
import { NamePipe }                        from '@shared/pipes/name.pipe';
import { ReplaceTextPlaceholdersPipe }     from '@shared/pipes/replace-text-placeholders.pipe';
import { StringPropertyFilterPipe }        from '@shared/pipes/string-property-filter.pipe';
import { ToEmptyStringPipe }               from '@shared/pipes/to-empty-string.pipe';
import { UpperCaseSeparatedPipe }          from '@shared/pipes/upper-case-separated.pipe';


@NgModule({
	declarations: [
		DateLocaleFormatPipe,
		KeyValueNotSortingByDefaultPipe,
		LineBreakHtmlConverterPipe,
		NamePipe,
		ReplaceTextPlaceholdersPipe,
		StringPropertyFilterPipe,
		ToEmptyStringPipe,
		UpperCaseSeparatedPipe,
	],
	exports: [
		DateLocaleFormatPipe,
		KeyValueNotSortingByDefaultPipe,
		LineBreakHtmlConverterPipe,
		NamePipe,
		ReplaceTextPlaceholdersPipe,
		ToEmptyStringPipe,
		UpperCaseSeparatedPipe,
		BypassSecurityTrustHtmlPipe
	],
	imports: [
		BypassSecurityTrustHtmlPipe,
		ExternalToInternalLinkPipe,
	],
	providers: [
		ToEmptyStringPipe
	]
})
export class PipesModule {}
